const firebaseConfig = {
    apiKey: "AIzaSyDv7SYhe5cD2QJfHmHRO0w3FNGNk_psGdI",
    authDomain: "safa-marua.firebaseapp.com",
    projectId: "safa-marua",
    storageBucket: "safa-marua.appspot.com",
    messagingSenderId: "802556256572",
    appId: "1:802556256572:web:b044d779743a2a468e7e39"
  };
  export default firebaseConfig;